// src/platform/PlatformApp.js — superadmin control panel shell. Rendered by
// App.js instead of the tenant EMS when the current host is the platform-admin
// host (GET /api/platform-context).
import React, { useState, useEffect } from 'react';
import { getPlatformMe } from '../utils/api';
import { Toast, useToast } from '../components/UI';
import PlatformLogin from './PlatformLogin';
import TenantList from './TenantList';
import '../index.css';

export default function PlatformApp() {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const { msg, show, clear } = useToast();

  useEffect(() => { document.title = 'Platform Admin'; }, []);

  useEffect(() => {
    const token = localStorage.getItem('bc_platform_token');
    if (token) {
      getPlatformMe()
        .then(r => setAdmin(r.data))
        .catch(() => localStorage.removeItem('bc_platform_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const signOut = () => { localStorage.removeItem('bc_platform_token'); setAdmin(null); };

  if (loading) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--gray-400)' }}>Loading...</div>;
  }
  if (!admin) return <PlatformLogin onLoggedIn={setAdmin} />;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--gray-50)' }}>
      <div style={{ background: 'var(--white)', borderBottom: '0.5px solid var(--gray-200)', padding: '0 24px', height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontSize: 15, fontWeight: 700 }}><span className="logo-dot" />Platform Admin</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontSize: 12, color: 'var(--gray-400)' }}>{admin.name} · {admin.email}</span>
          <button className="btn btn-outline btn-sm" onClick={signOut}><i className="ti ti-logout" /> Sign Out</button>
        </div>
      </div>
      <div style={{ maxWidth: 1040, margin: '0 auto', padding: 24 }}>
        <TenantList toast={show} />
      </div>
      <Toast message={msg} onClose={clear} />
    </div>
  );
}
